import bsPromisesSprite from '@/shared/assets/images/bs-promises-sprite.2x.png';
import { cn } from '@/shared/utils/cn';
import type { BsPromiseIconId } from '../data/bsPromises.data';

type BsPromiseIconVariant = 'grid' | 'detail';

const GRID_ICON_STYLES: Record<
  BsPromiseIconId,
  { width: number; height: number; backgroundPosition: string; backgroundSize?: string }
> = {
  refund: { width: 62, height: 62, backgroundPosition: '0 -223px' },
  exchange: { width: 62, height: 62, backgroundPosition: '-5px -343px', backgroundSize: '120% auto' },
  certified: { width: 80, height: 62, backgroundPosition: '0 -225px' },
  exclusive: { width: 70, height: 62, backgroundPosition: '0 -5px' },
};

const DETAIL_ICON_STYLES: Record<
  BsPromiseIconId,
  { width: number; height: number; backgroundPosition: string; backgroundSize?: string }
> = {
  refund: { width: 94, height: 94, backgroundPosition: '0 -336px' },
  exchange: { width: 100, height: 94, backgroundPosition: '-5px -505px', backgroundSize: '110% auto' },
  certified: { width: 120, height: 94, backgroundPosition: '0 -338px' },
  exclusive: { width: 100, height: 94, backgroundPosition: '0 -5px' },
};

interface BsPromiseIconProps {
  iconId: BsPromiseIconId;
  variant?: BsPromiseIconVariant;
  className?: string;
}

export function BsPromiseIcon({ iconId, variant = 'grid', className }: BsPromiseIconProps) {
  const iconStyle = variant === 'detail' ? DETAIL_ICON_STYLES[iconId] : GRID_ICON_STYLES[iconId];

  return (
    <span
      aria-hidden
      className={cn('inline-block bg-no-repeat', className)}
      style={{
        width: iconStyle.width,
        height: iconStyle.height,
        backgroundImage: `url(${bsPromisesSprite})`,
        backgroundPosition: iconStyle.backgroundPosition,
        backgroundSize: iconStyle.backgroundSize ?? '100% auto',
      }}
    />
  );
}
